import { DecimalPipe } from "@angular/common";
import { Directive, ElementRef, EventEmitter, Input, Output } from "@angular/core";
import { NgControl } from "@angular/forms";


@Directive({
  selector: '[DecimalTrail]',
  host: {
    '(focusout)': 'onInputChange($event.currentTarget)'
  }
})
export class DecimalTrail {

  constructor(public model: NgControl, private el: ElementRef) { }

  @Output() rawChange: EventEmitter<string> = new EventEmitter<string>();
  @Input() MaxVal: number;
  @Input() MinVal: number;
  // @Input() MaxChar: number;
  onInputChange(target) {
    let value = target.value;
    const numPipe = new DecimalPipe('en-Us');
    let tempAmount = ""// = 
    if (value !== '' && value.includes('.')) {
      const dec = value.split('.')[1];
      if (dec == "00" || dec == "" || dec == "0") {
        tempAmount = value.split('.')[0];
      } else {
        tempAmount = numPipe.transform(+parseFloat(value).toFixed(2), '1.2-2').replace(/,/g, '');
      }
    }
    else {
      tempAmount = value;
    }

    this.model.control.setValue(tempAmount, { emitViewToModelChange: false })
    this.rawChange.emit(tempAmount);
    if (this.MinVal !== undefined && this.MaxVal !== undefined) {
      const numAmount = +parseFloat(tempAmount);
      if (numAmount < this.MinVal || numAmount > this.MaxVal) {
        this.model.control.setErrors({ 'incorrect': true });
      } else {
        this.model.control.setErrors(null);
      }
    }
  }
}
